<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <slot name="loader"></slot>
    <div
      v-if="showWriteReviewPopup"
      ref="popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="rfp-rr-write-review-header-title"
      tabindex="-1"
      class="rfp-rr-ratings-write-review-178-or review-popup"
      :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
      style="display: block"
    >
      <div
        role="button"
        :aria-label="modalCloseButtonAccessibleLabel"
        tabindex="0"
        class="rfp-rr-ratings-write-review-179-or review-popup-close"
        :class="{ 'rfp-rr-rating-rtl-left': isRightToLeftActive }"
        @keydown.space.prevent
        @keyup.space="closePopup"
        @keydown.enter="closePopup"
        @click="closePopup"
      >
        X
      </div>
      <form
        id="formId"
        class="rfp-rr-ratings-write-review-180-or"
        method="post"
        novalidate=""
        @submit.prevent="submit"
      >
        <div class="rfp-rr-ratings-write-review-181-or popup-inner">
          <div class="rfp-rr-ratings-write-review-182-or review-popup-header">
            <span
              id="rfp-rr-write-review-header-title"
              role="heading"
              aria-level="2"
              v-html="headerTitle"
            ></span>
            <p class="rfp-rr-write-review-header-legend">
              {{ mandatoryFieldAccessibleLabel }}
            </p>
          </div>
          <div class="rfp-rr-ratings-write-review-183-or review-popup-body">
            <div
              v-if="userText != ''"
              class="rfp-rr-ratings-write-review-241-or body-row full-width"
              :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
              v-html="userText"
            ></div>
            <div
              class="rfp-rr-ratings-write-review-184-or body-row overall-rating"
              :class="{ 'label-hide-show': !showLabelOverallRating }"
            >
              <div
                id="rfp-rr-ratings-write-review-overall-rating-label"
                class="rfp-rr-ratings-write-review-185-or body-row-left"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                {{ labelOverallRating }} {{ !overallRatingValidation ? '*' : '' }}
              </div>
              <div
                class="rfp-rr-ratings-write-review-186-or body-row-right"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                <div class="rfp-rr-ratings-write-review-187-or stars">
                  <div class="rfp-rr-ratings-write-review-188-or star">
                    <refapp-star-rating
                      ref="overallRating"
                      aria-labelledby="rfp-rr-ratings-write-review-overall-rating-label"
                      :aria-label="starRatingAccessibleLabel"
                      class="vue-star-rating"
                      star-classes="vue-star-rating-star"
                      :increment="starRatingIncrementValue"
                      :max-rating="starRatingMaxRatingValue"
                      :inactive-color="starRatingInactiveColor"
                      :active-color="starRatingActiveColor"
                      :star-size="starRatingStarSize"
                      :rating="overallRating"
                      :required="!overallRatingValidation"
                      :aria-invalid="!!validation.firstError('overallRating')"
                      :aria-describedby="
                        !!validation.firstError('overallRating')
                          ? 'rfp-rr-ratings-write-review-overall-rating-label-error-message'
                          : null
                      "
                      @update:rating="overallRating = $event"
                    />
                  </div>
                </div>
                <div
                  class="rfp-rr-ratings-write-review-189-or star-label"
                  :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                >
                  <div>
                    {{
                      starRatingOverallRatingDescValue[overallRating] ||
                      starRatingOverallRatingDescValue[0]
                    }}
                  </div>
                </div>
                <p
                  v-if="validation.firstError('overallRating')"
                  id="rfp-rr-ratings-write-review-overall-rating-label-error-message"
                  class="rfp-rr-ratings-write-review-190-or Refapp-ratings-validation-error rfp-ratings-specificAlignment"
                >
                  {{ overallRatingFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-191-or body-row full-width"
              :class="{ 'label-hide-show': !showLabelReviewTitle }"
            >
              <label
                for="rfp-rr-ratings-write-review-title"
                class="rfp-rr-ratings-write-review-192-or body-row-left"
              >
                {{ labelReviewTitle }} {{ !reviewTitleValidation ? '*' : '' }}
              </label>
              <div class="rfp-rr-ratings-write-review-193-or body-row-right">
                <input
                  id="rfp-rr-ratings-write-review-title"
                  ref="reviewTitle"
                  v-model="reviewTitle"
                  type="text"
                  autocomplete="off"
                  :aria-required="!reviewTitleValidation"
                  :aria-invalid="!!validation.firstError('reviewTitle')"
                  :aria-describedby="
                    !!validation.firstError('reviewTitle')
                      ? 'rfp-rr-ratings-write-review-title-error-message'
                      : null
                  "
                  :placeholder="reviewTitlePlaceholder"
                  :maxlength="reviewTitleMaxLength"
                  name="reviewTitle"
                />
                <p
                  v-if="validation.firstError('reviewTitle')"
                  id="rfp-rr-ratings-write-review-title-error-message"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ reviewTitleFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-195-or body-row full-width"
              :class="{ 'label-hide-show': !showLabelReview }"
            >
              <label
                for="rfp-rr-ratings-write-review-review"
                class="rfp-rr-ratings-write-review-196-or body-row-left"
              >
                {{ labelReview }} {{ !reviewValidation ? '*' : '' }}
              </label>
              <div class="rfp-rr-ratings-write-review-197-or body-row-right">
                <textarea
                  id="rfp-rr-ratings-write-review-review"
                  ref="review"
                  v-model="review"
                  class="rfp-rr-ratings-write-review-198-or ratings-review-font"
                  :placeholder="reviewPlaceholder"
                  :maxlength="reviewMaxLength"
                  name="review"
                  :aria-required="!reviewValidation"
                  :aria-invalid="!!validation.firstError('review')"
                  :aria-describedby="
                    !!validation.firstError('review')
                      ? 'rfp-rr-ratings-write-review-review-error-message'
                      : null
                  "
                ></textarea>
                <p
                  v-if="validation.firstError('review')"
                  id="rfp-rr-ratings-write-review-review-error-message"
                  class="rfp-rr-ratings-write-review-199-or Refapp-ratings-validation-error"
                >
                  {{ reviewFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-200-or body-row recommend"
              :class="{
                'label-hide-show': !showLabelWouldYouRecommendProductToFriend,
              }"
            >
              <div
                id="rfp-rr-ratings-write-review-recommend-toggle-label"
                class="rfp-rr-ratings-write-review-201-or body-row-left"
              >
                {{ labelProductRecommend }}
              </div>
              <div class="rfp-rr-ratings-write-review-202-or body-row-right">
                <label
                  aria-labelledby="rfp-rr-ratings-write-review-recommend-toggle-label"
                  class="toggle-colors"
                  for="rfp-rr-ratings-write-review-recommend-toggle"
                >
                  <input
                    id="rfp-rr-ratings-write-review-recommend-toggle"
                    v-model="WouldYouRecommendThisProductToFriend"
                    type="checkbox"
                  />
                  <div
                    class="toggle"
                    :style="{
                      '--inactive-color': toggleButtonInactiveColor,
                      '--active-color': toggleButtonActiveColor,
                      '--toggle-yes': `'${toggleButtonActiveLabel}'`,
                      '--toggle-no': `'${toggleButtonInactiveLabel}'`,
                    }"
                  ></div>
                </label>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-235-or body-row"
              :class="{ 'label-hide-show': !userTypeShowHide }"
            >
              <div class="rfp-rr-ratings-write-review-236-or body-col">
                <label
                  for="rfp-rr-ratings-write-review-user-types"
                  class="rfp-rr-ratings-write-review-237-or rfp-user-type-label body-row-left"
                >
                  {{ userType }} {{ !userTypeValidation ? '*' : '' }}
                </label>
              </div>
              <div class="rfp-rr-ratings-write-review-238-or body-col">
                <div class="rfp-rr-ratings-write-review-239-or body-row-right">
                  <select
                    id="rfp-rr-ratings-write-review-user-types"
                    ref="userTypes"
                    v-model="userTypes"
                    class="rfp-rr-ratings-write-review-240-or"
                    :aria-required="!userTypeValidation"
                    :aria-invalid="!!validation.firstError('userTypes')"
                    :aria-describedby="
                      !!validation.firstError('userTypes')
                        ? 'rfp-rr-ratings-write-review-user-types-error-message'
                        : null
                    "
                    name="userTypes"
                  >
                    <option value="">{{ dropDownSelectText }}</option>
                    <option v-for="x in userTypeDatas" :key="x" :value="x">{{ x }}</option>
                  </select>
                  <p
                    v-if="validation.firstError('userTypes')"
                    id="rfp-rr-ratings-write-review-user-types-error-message"
                    class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                  >
                    {{ userTypesFieldValidationMsg }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-204-or body-row"
              :class="{
                'label-hide-show': !showLabelLocation && !showLabelNickname,
              }"
            >
              <div
                class="rfp-rr-ratings-write-review-205-or"
                :class="{
                  'label-hide-show': !showLabelNickname,
                  ' body-col': showLabelLocation,
                }"
              >
                <label
                  for="rfp-rr-ratings-write-review-nickname"
                  class="rfp-rr-ratings-write-review-206-or body-row-left"
                >
                  {{ labelNickname }} {{ !nicknameValidation ? '*' : '' }}
                </label>
                <div class="rfp-rr-ratings-write-review-207-or body-row-right">
                  <input
                    id="rfp-rr-ratings-write-review-nickname"
                    ref="nickname"
                    v-model="nickname"
                    autocomplete="nickname"
                    :placeholder="nicknamePlaceholder"
                    :maxlength="nicknameMaxLength"
                    :aria-required="!nicknameValidation"
                    :aria-invalid="!!validation.firstError('nickname')"
                    :aria-describedby="
                      !!validation.firstError('nickname')
                        ? 'rfp-rr-ratings-write-review-nickname-error-message'
                        : null
                    "
                    name="nickname"
                    type="text"
                  />
                  <p
                    v-if="validation.firstError('nickname')"
                    id="rfp-rr-ratings-write-review-nickname-error-message"
                    class="rfp-rr-ratings-write-review-208-or Refapp-ratings-validation-error"
                  >
                    {{ nicknameFieldValidationMsg }}
                  </p>
                </div>
              </div>
              <div
                class="rfp-rr-ratings-write-review-209-or"
                :class="{
                  'label-hide-show': !showLabelLocation,
                  ' body-col': showLabelNickname,
                }"
              >
                <label
                  for="rfp-rr-ratings-write-review-location"
                  class="rfp-rr-ratings-write-review-210-or body-row-left"
                >
                  {{ labelLocation }} {{ !locationValidation ? '*' : '' }}
                </label>
                <div class="rfp-rr-ratings-write-review-211-or body-row-right">
                  <input
                    id="rfp-rr-ratings-write-review-location"
                    ref="location"
                    v-model="location"
                    :placeholder="locationPlaceholder"
                    :maxlength="locationMaxLength"
                    name="location"
                    autocomplete="address-level2"
                    type="text"
                    :aria-required="!locationValidation"
                    :aria-invalid="!!validation.firstError('location')"
                    :aria-describedby="
                      !!validation.firstError('location')
                        ? 'rfp-rr-ratings-write-review-location-error-message'
                        : null
                    "
                  />
                  <p
                    v-if="validation.firstError('location')"
                    id="rfp-rr-ratings-write-review-location-error-message"
                    class="rfp-rr-ratings-write-review-212-or Refapp-ratings-validation-error"
                  >
                    {{ locationFieldValidationMsg }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-213-or body-row"
              :class="{
                'label-hide-show': !showHowOldAreYou && !showLabelEmail,
              }"
            >
              <div
                class="rfp-rr-ratings-write-review-214-or"
                :class="{
                  'label-hide-show': !showLabelEmail,
                  'body-col': showHowOldAreYou,
                }"
              >
                <label
                  for="rfp-rr-ratings-write-review-email"
                  class="rfp-rr-ratings-write-review-215-or body-row-left"
                >
                  {{ labelEmail }} {{ !emailValidation ? '*' : '' }}
                </label>
                <div class="rfp-rr-ratings-write-review-216-or body-row-right">
                  <input
                    id="rfp-rr-ratings-write-review-email"
                    ref="emailStatus"
                    v-model="emailStatus"
                    :placeholder="emailPlaceholder"
                    type="text"
                    autocomplete="email"
                    name="emailStatus"
                    :aria-required="!emailValidation"
                    :aria-invalid="!!validation.firstError('emailStatus')"
                    :aria-describedby="
                      !!validation.firstError('emailStatus')
                        ? 'rfp-rr-ratings-write-review-email-error-message'
                        : null
                    "
                  />
                  <p
                    v-if="validation.firstError('emailStatus')"
                    id="rfp-rr-ratings-write-review-email-error-message"
                    class="rfp-rr-ratings-write-review-217-or Refapp-ratings-validation-error"
                  >
                    {{ emailFieldValidationMsg }}
                  </p>
                </div>
              </div>
              <div
                class="rfp-rr-ratings-write-review-218-or"
                :class="{
                  'label-hide-show': !showHowOldAreYou,
                  'body-col': showLabelEmail,
                }"
              >
                <label
                  for="rfp-rr-ratings-write-review-age"
                  class="rfp-rr-ratings-write-review-219-or body-row-left"
                >
                  {{ labelHowOldAreYou }} {{ !ageRangeValidation ? '*' : '' }}
                </label>
                <div class="rfp-rr-ratings-write-review-220-or body-row-right">
                  <select
                    id="rfp-rr-ratings-write-review-age"
                    ref="AgeRange"
                    v-model="AgeRange"
                    class="rfp-rr-ratings-write-review-221-or"
                    name="AgeRange"
                    :aria-required="!ageRangeValidation"
                    :aria-invalid="!!validation.firstError('AgeRange')"
                    :aria-describedby="
                      !!validation.firstError('AgeRange')
                        ? 'rfp-rr-ratings-write-review-age-error-message'
                        : null
                    "
                  >
                    <option value="">{{ dropDownSelectText }}</option>
                    <option v-for="x in howOldAreYouInputValue" :key="x" :value="x">{{ x }}</option>
                  </select>
                  <p
                    v-if="validation.firstError('AgeRange')"
                    id="rfp-rr-ratings-write-review-age-error-message"
                    class="rfp-rr-ratings-write-review-212-a-or Refapp-ratings-validation-error"
                  >
                    {{ ageRangeFieldValidationMsg }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-222-or body-row quality"
              :class="{
                'label-hide-show': !showHowWouldYouRateThisQualityOfThisProduct,
              }"
            >
              <div
                id="rfp-rr-ratings-write-review-quality-of-this-product-label"
                class="rfp-rr-ratings-write-review-223-or body-row-left"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                {{ labelHowWouldYouRateThisQualityOfThisProduct }}
                {{ !howWouldYouRateThisQualityOfThisProductValidation ? '*' : '' }}
              </div>
              <div class="rfp-rr-ratings-write-review-224-or body-row-right">
                <div class="rfp-rr-ratings-write-review-225-or stars">
                  <div
                    class="rfp-rr-ratings-write-review-226-or star"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                  >
                    <refapp-star-rating
                      ref="HowWouldYouRateThisQualityOfThisProduct"
                      aria-labelledby="rfp-rr-ratings-write-review-quality-of-this-product-label"
                      :aria-label="starRatingAccessibleLabel"
                      class="vue-star-rating"
                      star-classes="vue-star-rating-star"
                      :increment="starRatingIncrementValue"
                      :max-rating="starRatingMaxRatingValue"
                      :inactive-color="starRatingInactiveColor"
                      :active-color="starRatingActiveColor"
                      :star-size="starRatingStarSize"
                      :rating="HowWouldYouRateThisQualityOfThisProduct"
                      :required="!howWouldYouRateThisQualityOfThisProductValidation"
                      :aria-invalid="
                        !!validation.firstError('HowWouldYouRateThisQualityOfThisProduct')
                      "
                      :aria-describedby="
                        !!validation.firstError('HowWouldYouRateThisQualityOfThisProduct')
                          ? 'rfp-rr-ratings-write-review-quality-of-product-error-message'
                          : null
                      "
                      @update:rating="HowWouldYouRateThisQualityOfThisProduct = $event"
                    >
                    </refapp-star-rating>
                  </div>
                </div>
                <div class="rfp-rr-ratings-write-review-227-or star-label">
                  <div>
                    {{
                      starRatingOverallRatingDescValue[overallRating] ||
                      starRatingOverallRatingDescValue[0]
                    }}
                  </div>
                </div>
                <p
                  v-if="validation.firstError('HowWouldYouRateThisQualityOfThisProduct')"
                  id="rfp-rr-ratings-write-review-quality-of-product-error-message"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ qualityOfThisProductFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-222-or body-row quality"
              :class="{ 'label-hide-show': !showLabelYesOrNoRadio }"
            >
              <div
                id="rfp-rr-ratings-write-review-sample-radio"
                class="rfp-rr-ratings-write-review-223-or body-row-left"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                {{ yesOrNoRadioButtonLabelText }} {{ !yesOrNoRadioCmsValidation ? '*' : '' }}
              </div>
              <div
                role="radiogroup"
                aria-labelledby="rfp-rr-ratings-write-review-sample-radio"
                :aria-required="!yesOrNoRadioCmsValidation"
                :aria-invalid="!!validation.firstError('yesOrNoRadioValue')"
                :aria-describedby="
                  !!validation.firstError('yesOrNoRadioValue')
                    ? 'rfp-rr-ratings-write-review-sample-radio-error-message'
                    : null
                "
                class="rfp-rr-ratings-write-review-224-or body-row-left"
              >
                <label
                  for="rfp-rr-ratings-write-review-sample-yes"
                  class="rfp-rr-ratings-radio-label"
                >
                  <input
                    id="rfp-rr-ratings-write-review-sample-yes"
                    ref="yesOrNoRadioValue"
                    v-model="yesOrNoRadioValue"
                    type="radio"
                    value="true"
                  />
                  {{ yesRadioButtonLabelText }}
                </label>
                <label
                  for="rfp-rr-ratings-write-review-sample-no"
                  class="rfp-rr-ratings-radio-label"
                >
                  <input
                    id="rfp-rr-ratings-write-review-sample-no"
                    v-model="yesOrNoRadioValue"
                    type="radio"
                    value="false"
                  />
                  {{ noRadioButtonLabelText }}
                </label>
                <p
                  v-if="validation.firstError('yesOrNoRadioValue')"
                  id="rfp-rr-ratings-write-review-sample-radio-error-message"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ yesOrNoRadioButtonValidationMsg }}
                </p>
              </div>
            </div>
            <rfp-ratings-write-optional-select
              v-if="
                fields.howDidYouHearAboutTheProductLabelShowHide &&
                fields.howDidYouHearAboutTheProductDatas?.length
              "
              id="howDidYouHearAboutTheProduct"
              ref="howDidYouHearAboutTheProduct"
              :label="fields.howDidYouHearAboutTheProductLabel"
              :default-option="dropDownSelectText"
              :options="fields.howDidYouHearAboutTheProductDatas"
              :validation-error="validation.firstError('howDidYouHearAboutTheProduct')"
              :validation-error-message="fields.howDidYouHearAboutTheProductFieldValidationMsg"
              :required="!fields.howDidYouHearAboutTheProductValidation"
              @update="howDidYouHearAboutTheProduct = $event"
            ></rfp-ratings-write-optional-select>
            <rfp-ratings-write-optional-select
              v-if="fields.genderLabelShowHide && fields.genderValueDatas?.length"
              id="userGender"
              ref="genderValue"
              :label="fields.genderLabel"
              :default-option="dropDownSelectText"
              :options="fields.genderValueDatas"
              :validation-error="validation.firstError('genderValue')"
              :validation-error-message="fields.genderValidationMsg"
              :required="!fields.genderValidation"
              @update="genderValue = $event"
            ></rfp-ratings-write-optional-select>
            <rfp-ratings-write-optional-stars
              v-if="
                fields.effectivenessOfTheProductLabelShowHide &&
                fields.effectivenessOfTheProduct instanceof Object &&
                Object.keys(fields.effectivenessOfTheProduct).length > 0
              "
              id="rfp-rr-ratings-write-review-effectiveness-of-the-product"
              ref="effectivenessOfTheProduct"
              :label="fields.effectivenessOfTheProductLabel"
              :options="fields.effectivenessOfTheProduct"
              :validation-error="validation.firstError('effectivenessOfTheProduct')"
              :validation-error-message="fields.effectivenessOfTheProductValidationMsg"
              :rtl="isRightToLeftActive"
              :value="effectivenessOfTheProduct"
              :required="!fields.effectivenessOfTheProductValidation"
              @update="effectivenessOfTheProduct = $event"
            ></rfp-ratings-write-optional-stars>
            <rfp-ratings-write-optional-stars
              v-if="
                fields.textureOfTheProductLabelShowHide &&
                fields.textureOfTheProduct instanceof Object &&
                Object.keys(fields.textureOfTheProduct).length > 0
              "
              id="rfp-rr-ratings-write-review-texture-of-the-product-label"
              ref="textureOfTheProduct"
              :label="fields.textureOfTheProductLabel"
              :options="fields.textureOfTheProduct"
              :validation-error="validation.firstError('textureOfTheProduct')"
              :validation-error-message="fields.textureOfTheProductValidationMsg"
              :rtl="isRightToLeftActive"
              :value="textureOfTheProduct"
              :required="!fields.textureOfTheProductValidation"
              @update="textureOfTheProduct = $event"
            ></rfp-ratings-write-optional-stars>
            <rfp-ratings-write-optional-stars
              v-if="
                fields.pricePositionOfTheProductLabelShowHide &&
                fields.pricePositionOfTheProduct instanceof Object &&
                Object.keys(fields.pricePositionOfTheProduct).length > 0
              "
              id="rfp-rr-ratings-write-review-price-position-of-the-product"
              ref="pricePositionOfTheProduct"
              :label="fields.pricePositionOfTheProductLabel"
              :options="fields.effectivenessOfTheProduct"
              :validation-error="validation.firstError('pricePositionOfTheProduct')"
              :validation-error-message="fields.pricePositionOfTheProductValidationMsg"
              :rtl="isRightToLeftActive"
              :value="pricePositionOfTheProduct"
              :required="!fields.pricePositionOfTheProductValidation"
              @update="pricePositionOfTheProduct = $event"
            ></rfp-ratings-write-optional-stars>
            <div
              class="rfp-rr-ratings-write-review-228-or body-row full-width"
              :class="{
                'label-hide-show': !showLabelWouldYouRecommendThisProductToFriend,
              }"
            >
              <label for="rfp-rr-wouldYouRecommendBrandToAFriend" class="body-row-left">
                {{ labelWouldYouRecommendThisProductToFriend }}
              </label>
              <div class="rfp-rr-ratings-write-review-229-or body-row-right">
                <div
                  class="rfp-rr-ratings-write-review-230-or recommend-slider"
                  :style="`--range-slider-marker-position: ${(wouldYouRecommendBrandToAFriend / recommendToFriendRatingScale) * 100}%;`"
                >
                  <div aria-hidden="true" class="rfp-range-input-slider-marker-wrapper">
                    <div class="rfp-range-input-slider-marker">
                      {{ wouldYouRecommendBrandToAFriend }}
                    </div>
                  </div>
                  <input
                    id="rfp-rr-wouldYouRecommendBrandToAFriend"
                    v-model="wouldYouRecommendBrandToAFriend"
                    class="rfp-range-input-slider"
                    type="range"
                    name="wouldYouRecommendBrandToAFriend"
                    min="0"
                    :max="recommendToFriendRatingScale"
                    step="1"
                    value="0"
                  />
                  <div aria-hidden="true" class="rfp-range-input-slider-step-labels-wrapper">
                    <div
                      v-for="i in recommendToFriendRatingScale + 1"
                      :key="i"
                      class="rfp-range-input-slider-step-label"
                    >
                      {{ i - 1 }}
                    </div>
                  </div>
                </div>
                <p
                  v-if="validation.firstError('wouldYouRecommendBrandToAFriend')"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ recommendProductToFriendFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div v-if="imageUpload.Active" class="body-row full-width">
              <rfp-ratings-upload-image
                :config="imageUpload.Config"
                :dictionary="imageUpload.ImageUploadDictionary"
              ></rfp-ratings-upload-image>
            </div>
            <div
              class="rfp-rr-ratings-write-review-231-or checkboxes body-row form-terms-use"
              :class="{
                'label-hide-show': !showLabelTermsOfUse,
                'rfp-rr-rating-rtl-float-right': isRightToLeftActive,
              }"
            >
              <label
                for="rfp-rr-ratings-write-review-terms"
                class="rfp-rr-ratings-write-review-232-or mobile-terms"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                <input
                  id="rfp-rr-ratings-write-review-terms"
                  ref="termsOfUse"
                  v-model="termsOfUse"
                  type="checkbox"
                  aria-required="true"
                  :aria-invalid="!!validation.firstError('termsOfUse')"
                  class="rfp-rr-ratings-write-review-233-or checkbox--rr-design"
                  :class="{ 'rfp-rr-rating-rtl-right': isRightToLeftActive }"
                />
                <p
                  class="form-terms-use__description"
                  :class="{
                    error__text__red: validation.firstError('termsOfUse'),
                    'rfp-rr-rating-rtl-write-review-tearms': isRightToLeftActive,
                  }"
                  v-html="`${labelTermsOfUseStepOne} *`"
                ></p>
              </label>
            </div>
            <div
              v-for="e in errors"
              :key="e"
              class="body-row Refapp-ratings-validation-error"
              v-text="e"
            ></div>
            <div class="rfp-rr-ratings-write-review-234-or body-row action-row">
              <input
                type="submit"
                :disabled="submitting"
                :value="reviewButtonText"
                class="button button-primary"
                :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import SimpleVueValidation from 'simple-vue-validator';
import axios from 'axios';
import RfpRatingsUploadImage from '../rfp-ratings-upload-images/rfp-ratings-upload-image.vue';
import RfpRatingsWriteOptionalSelect from './rfp-ratings-write-optional-select.vue';
import RfpRatingsWriteOptionalStars from './rfp-ratings-write-optional-stars.vue';
import RefappStarRating from '../../../../../shared/components/star-rating/refapp-star-rating.vue';
import { trapFocus } from '../../../../../shared/utils/dom/focus';

const Validator = SimpleVueValidation.Validator;
const RATINGS_REVIEWS_BODY_CLASS = 'rare-custom-body-class';
const ENABLE_LOADING_EVENT = 'rfp-common-loading-enable';

export default {
  name: 'rfp-ratings-write-review',
  components: {
    RfpRatingsUploadImage,
    RfpRatingsWriteOptionalSelect,
    RfpRatingsWriteOptionalStars,
    RefappStarRating,
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      increment: this.$props.starRatingIncrementValue,
      maxRating: this.$props.starRatingMaxRatingValue,
      inactiveColor: this.$props.starRatingInactiveColor,
      activeColor: this.$props.starRatingActiveColor,
      starSize: this.$props.starRatingStarSize,
      starRatingAccessibleLabel: this.$props.starRatingAccessibleLabel,
    };
  },
  props: {
    imageUpload: {
      type: Object,
      default() {
        return {
          Active: true,
        };
      },
    },
    action: {
      type: String,
      required: true,
    },
    headerTitle: {
      type: String,
      required: true,
    },
    userText: {
      type: String,
      required: true,
    },
    languageName: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
    labelOverallRating: {
      type: String,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    toggleButtonActiveColor: {
      type: String,
      default: '#FB2460',
    },
    toggleButtonInactiveColor: {
      type: String,
      default: '#EEE',
    },
    toggleButtonActiveLabel: {
      type: String,
      default: 'Y',
    },
    toggleButtonInactiveLabel: {
      type: String,
      default: 'N',
    },
    starRatingOverallRatingDesc: {
      type: Object,
      required: true,
    },
    starRatingOverallRatingDefault: {
      type: String,
      default: 'Click to rate!',
    },
    overallRatingFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelReviewTitle: {
      type: String,
      required: true,
    },
    reviewTitlePlaceholder: {
      type: String,
      required: true,
    },
    reviewTitleFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelReview: {
      type: String,
      required: true,
    },
    reviewPlaceholder: {
      type: String,
      required: true,
    },
    reviewFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelNickname: {
      type: String,
      required: true,
    },
    nicknamePlaceholder: {
      type: String,
      required: true,
    },
    nicknameFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelLocation: {
      type: String,
      required: true,
    },
    locationPlaceholder: {
      type: String,
      required: true,
    },
    locationFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelEmail: {
      type: String,
      required: true,
    },
    emailPlaceholder: {
      type: String,
      required: true,
    },
    emailFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelWouldYouRecommendThisProductToFriend: {
      type: String,
      required: true,
    },
    labelTermsOfUseStepOne: {
      type: String,
      required: true,
    },
    showLabelOverallRating: {
      type: Boolean,
      default: false,
    },
    showLabelReviewTitle: {
      type: Boolean,
      default: false,
    },
    showLabelReview: {
      type: Boolean,
      default: false,
    },
    showLabelNickname: {
      type: Boolean,
      default: false,
    },
    showLabelLocation: {
      type: Boolean,
      default: false,
    },
    showLabelEmail: {
      type: Boolean,
      default: false,
    },
    showLabelWouldYouRecommendThisProductToFriend: {
      type: Boolean,
      default: true,
    },
    showLabelTermsOfUse: {
      type: Boolean,
      default: false,
    },
    labelHowOldAreYou: {
      type: String,
      required: true,
    },
    showHowOldAreYou: {
      type: Boolean,
      default: false,
    },
    showLabelWouldYouRecommendProductToFriend: {
      type: Boolean,
      default: false,
    },
    labelHowWouldYouRateThisQualityOfThisProduct: {
      type: String,
      required: true,
    },
    showHowWouldYouRateThisQualityOfThisProduct: {
      type: Boolean,
      default: false,
    },
    howWouldYouRateThisQualityOfThisProductDesc: {
      type: Object,
      required: true,
    },
    howWouldYouRateThisQualityOfThisProductDefault: {
      type: String,
      required: true,
    },
    howOldAreYouInputValue: {
      type: Array,
      required: true,
    },
    productItemId: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    reviewTitleMaxLength: {
      type: Number,
      required: true,
    },
    reviewMaxLength: {
      type: Number,
      required: true,
    },
    nicknameMaxLength: {
      type: Number,
      required: true,
    },
    locationMaxLength: {
      type: Number,
      required: true,
    },
    signinNickname: {
      type: String,
      default: '',
    },
    signinLocation: {
      type: String,
      default: '',
    },
    signinEmail: {
      type: String,
      default: '',
    },
    labelProductRecommend: {
      type: String,
      required: true,
    },
    userTypeDatas: {
      type: Array,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
    userTypeShowHide: {
      type: Boolean,
      required: true,
    },
    reviewButtonText: {
      type: String,
      default: 'Post Review',
    },
    dropDownSelectText: {
      type: String,
      default: 'Post Review',
    },
    recommendToFriendRatingScale: {
      type: Number,
      required: true,
    },
    overallRatingValidation: {
      type: Boolean,
      default: true,
    },
    reviewTitleValidation: {
      type: Boolean,
      default: true,
    },
    reviewValidation: {
      type: Boolean,
      default: true,
    },
    nicknameValidation: {
      type: Boolean,
      default: true,
    },
    locationValidation: {
      type: Boolean,
      default: true,
    },
    emailValidation: {
      type: Boolean,
      default: true,
    },
    ageRangeValidation: {
      type: Boolean,
      default: true,
    },
    ageRangeFieldValidationMsg: {
      type: String,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    isRecommendRatingOptionalValidation: {
      type: Boolean,
      default: true,
    },
    howWouldYouRateThisQualityOfThisProductValidation: {
      type: Boolean,
      default: true,
    },
    isRecommendOptionalValidation: {
      type: Boolean,
      default: true,
    },
    userTypeValidation: {
      type: Boolean,
      default: true,
    },
    userTypesFieldValidationMsg: {
      type: String,
      default: 'User type required',
    },
    qualityOfThisProductFieldValidationMsg: {
      type: String,
      default: 'Quality of product required',
    },
    recommendProductToFriendFieldValidationMsg: {
      type: String,
      default: 'Recommend to a friend required',
    },
    yesOrNoRadioButtonLabelText: {
      type: String,
      default: 'Hai ricevuto un campione gratuito di questo prodotto?',
    },
    yesOrNoRadioButtonValidationMsg: {
      type: String,
      default: 'Required',
    },
    yesOrNoRadioCmsValidation: {
      type: Boolean,
      default: true,
    },
    showLabelYesOrNoRadio: {
      type: Boolean,
      default: true,
    },
    yesRadioButtonLabelText: {
      type: String,
      default: 'Yes',
    },
    noRadioButtonLabelText: {
      type: String,
      default: 'No',
    },
    utmParameters: {
      type: Object,
      default() {
        return { UtmSource: '', UtmCampaign: '', UtmMedium: '' };
      },
    },
    fields: {
      type: Object,
      default: () => {},
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
    starRatingAccessibleLabel: {
      type: String,
      default: undefined,
    },
    mandatoryFieldAccessibleLabel: {
      type: String,
      default: 'Mandatory fields have a * marker',
    },
  },
  data() {
    /* istanbul ignore next */
    return {
      rangeSliderConfig: {
        show: true,
        value: 0,
        min: 0,
        max: this.recommendToFriendRatingScale,
        marks: true,
        tooltip: 'always',
      },
      termsOfUse: false,
      testValidation: '',
      overallRating: 0,
      overallRatings: 0,
      HowWouldYouRateThisQualityOfThisProduct: 0,
      WouldYouRecommendThisProductToFriend: false,
      reviewTitle: '',
      review: '',
      nickname: this.signinNickname,
      location: this.signinLocation,
      emailStatus: this.signinEmail,
      wouldYouRecommendBrandToAFriend: 0,
      AgeRange: '',
      showWriteReviewPopup: false,
      userTypes: '',
      activeSlider: false,
      submitting: false,
      vueSliderRtl: 'ltr',
      yesOrNoRadioValue: '',
      // addon fields
      howDidYouHearAboutTheProduct: '',
      genderValue: '',
      effectivenessOfTheProduct: 0,
      textureOfTheProduct: 0,
      pricePositionOfTheProduct: 0,
      // end addon fields
      toggleButtonColor: {
        checked: this.toggleButtonActiveColor,
        unchecked: this.toggleButtonInactiveColor,
      },
      toggleButtonLabels: {
        checked: this.toggleButtonActiveLabel,
        unchecked: this.toggleButtonInactiveLabel,
      },
      getUtmParameterDatas: {},
      errors: [],
      deactivateFocusTrap: null,
    };
  },
  /**
   * The order of validator properties must follow the html order
   * of the elements to ensure that the first element with error
   * will be focused on invalid form submit.
   */
  validators: {
    overallRating(value) {
      /* istanbul ignore next */
      if (!this.overallRatingValidation) {
        return Validator.value(value).required().greaterThan(0);
      }
      return Validator.value(value);
    },
    reviewTitle(value) {
      /* istanbul ignore next */
      if (!this.reviewTitleValidation) {
        return Validator.value(value).required().maxLength(this.reviewTitleMaxLength);
      }
      return Validator.value(value);
    },
    review(value) {
      /* istanbul ignore next */
      if (!this.reviewValidation) {
        return Validator.value(value).required().maxLength(this.reviewMaxLength);
      }
      return Validator.value(value);
    },
    userTypes(value) {
      /* istanbul ignore next */
      if (this.userTypeValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    nickname(value) {
      /* istanbul ignore next */
      if (!this.nicknameValidation) {
        return Validator.value(value).required().maxLength(this.nicknameMaxLength);
      }
      return Validator.value(value);
    },
    location(value) {
      /* istanbul ignore next */
      if (!this.locationValidation) {
        return Validator.value(value).required().maxLength(this.locationMaxLength);
      }
      return Validator.value(value);
    },
    emailStatus(value) {
      /* istanbul ignore next */
      if (this.emailValidation) {
        return Validator.value(value).email();
      }
      return Validator.value(value).required().email();
    },
    AgeRange(value) {
      /* istanbul ignore next */
      if (this.ageRangeValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    HowWouldYouRateThisQualityOfThisProduct(value) {
      /* istanbul ignore next */
      if (!this.howWouldYouRateThisQualityOfThisProductValidation) {
        return Validator.value(value).required().greaterThanOrEqualTo(1);
      }
      return Validator.value(value);
    },
    yesOrNoRadioValue(value) {
      /* istanbul ignore next */
      if (this.yesOrNoRadioCmsValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    WouldYouRecommendThisProductToFriend(value) {
      /* istanbul ignore next */
      if (this.isRecommendOptionalValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    howDidYouHearAboutTheProduct(value) {
      // logic is inverted because OF COURSE IT IS! FALSE means it SHOULD be validated
      if (
        this.fields.howDidYouHearAboutTheProductValidation === false &&
        this.fields.howDidYouHearAboutTheProductDatas?.length
      ) {
        return Validator.value(value).required();
      }
      return Validator.value(value);
    },
    genderValue(value) {
      if (this.fields.genderValidation === false && this.fields.genderValueDatas?.length) {
        return Validator.value(value).required();
      }
      return Validator.value(value);
    },
    effectivenessOfTheProduct(value) {
      if (
        this.fields.effectivenessOfTheProductValidation === false &&
        this.fields.effectivenessOfTheProduct instanceof Object &&
        Object.keys(this.fields.effectivenessOfTheProduct).length
      ) {
        // using this validator enables keeping the same numeric type for the value
        // instead of relying on an initial value of ''
        return Validator.value(value).integer().greaterThan(0);
      }
      return Validator.value(value);
    },
    textureOfTheProduct(value) {
      if (
        this.fields.textureOfTheProductValidation === false &&
        this.fields.textureOfTheProduct instanceof Object &&
        Object.keys(this.fields.textureOfTheProduct).length
      ) {
        return Validator.value(value).integer().greaterThan(0);
      }
      return Validator.value(value);
    },
    pricePositionOfTheProduct(value) {
      if (
        this.fields.pricePositionOfTheProductValidation === false &&
        this.fields.pricePositionOfTheProduct instanceof Object &&
        Object.keys(this.fields.pricePositionOfTheProduct).length
      ) {
        return Validator.value(value).integer().greaterThan(0);
      }
      return Validator.value(value);
    },
    wouldYouRecommendBrandToAFriend(value) {
      /* istanbul ignore next */
      if (!this.isRecommendRatingOptionalValidation) {
        return Validator.value(value).required().minLength(1);
      }
      return Validator.value(value);
    },
    termsOfUse(value) {
      this.termsOfUse = value || '';
      return Validator.value(value).required();
    },
  },
  computed: {
    starRatingOverallRatingDescValue() {
      return [
        this.starRatingOverallRatingDefault,
        this.starRatingOverallRatingDesc.one,
        this.starRatingOverallRatingDesc.two,
        this.starRatingOverallRatingDesc.three,
        this.starRatingOverallRatingDesc.four,
        this.starRatingOverallRatingDesc.five,
      ];
    },
  },
  watch: {
    async showWriteReviewPopup(newVal) {
      if (newVal) {
        await this.$nextTick();
        this.deactivateFocusTrap = trapFocus(this.$refs.popup);
      } else {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('show-write-review', () => {
      document.body.classList.add(RATINGS_REVIEWS_BODY_CLASS);
      this.showWriteReviewPopup = true;
      this.activeSlider = true;
    });
    /* istanbul ignore next */
    eventBus.on('activeSliderWriteReview', () => {
      this.activeSlider = false;
    });
    this.getUtmParameters();
  },
  mounted() {
    eventBus.emit(ENABLE_LOADING_EVENT, true);

    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.showWriteReviewPopup && event.key === 'Escape') {
        this.closePopup();
      }
    },
    closePopup() {
      this.showWriteReviewPopup = false;
      this.activeSlider = false;
      document.body.classList.remove(RATINGS_REVIEWS_BODY_CLASS);
      eventBus.emit('ScrollTrue');
      this.validation.reset();
    },
    getUtmParameters(args) {
      if (args === '') return;
      return new URLSearchParams(window.location.search).get(args);
    },
    submit() {
      /* istanbul ignore next */
      if (this.overallRating === 0) {
        this.overallRating = '';
      }
      /* istanbul ignore next */
      this.$validate().then((isFormValid) => {
        if (!isFormValid) {
          const errorField = this.validation.errors[0].field;

          errorField && this.$refs[errorField].focus();
        }
        if (isFormValid && this.termsOfUse && !this.submitting) {
          this.submitting = true; // block the interface
          if (this.nickname === '') {
            this.nickname = 'Anonymous';
          }
          const datas = {
            Images: window.imgStorage ? window.imgStorage : [],
            ReviewTitle: this.reviewTitle,
            ReviewContent: this.review,
            NickName: this.nickname,
            Location: this.location,
            Email: this.emailStatus,
            AgeRange: this.AgeRange,
            ProductRating: this.overallRating,
            QualityRating: this.HowWouldYouRateThisQualityOfThisProduct,
            IsRecommend: this.WouldYouRecommendThisProductToFriend,
            RecommendRating: this.wouldYouRecommendBrandToAFriend,
            productItemId: this.productItemId,
            productId: this.productId,
            languageName: this.languageName,
            productName: this.productName,
            languageCode: this.languageCode,
            UserType: this.userTypes,
            IsProductGivenFree: this.yesOrNoRadioValue,
            UtmSource: this.getUtmParameters(this.utmParameters.UtmSource),
            UtmCampaign: this.getUtmParameters(this.utmParameters.UtmCampaign),
            UtmMedium: this.getUtmParameters(this.utmParameters.UtmMedium),
            // New Fields
            ProductVoice: this.howDidYouHearAboutTheProduct,
            Gender: this.genderValue,
            EffectivenessRating: this.effectivenessOfTheProduct,
            TextureRating: this.textureOfTheProduct,
            PricePositionRating: this.pricePositionOfTheProduct,
          };
          eventBus.emit(ENABLE_LOADING_EVENT, true);
          axios
            .post(this.action, {
              formData: datas,
            })
            .then((response) => {
              if (response.data.Message === 'Success') {
                eventBus.emit('PostReviewTags', this.overallRating);
                this.showWriteReviewPopup = false;
                eventBus.emit('showSuccessReview');
              } else {
                this.showWriteReviewPopup = false;
                eventBus.emit('show-review-warning');
              }
              this.reviewTitle = '';
              this.review = '';
              this.nickname = '';
              this.location = '';
              this.emailStatus = '';
              this.AgeRange = '';
              this.userTypes = '';
              this.overallRating = 0;
              this.HowWouldYouRateThisQualityOfThisProduct = 0;
              this.WouldYouRecommendThisProductToFriend = false;
              this.wouldYouRecommendBrandToAFriend = 0;
              this.termsOfUse = false;
              this.validation.reset();
              this.activeSlider = false;
              document.body.classList.remove(RATINGS_REVIEWS_BODY_CLASS);
            })
            .catch((e) => {
              // TODO: log errors instead and display a user friendly failure message
              this.errors.push(e);
            })
            .finally(() => {
              // this event controls the loader instance
              eventBus.emit(ENABLE_LOADING_EVENT, false);
              this.submitting = false; // unblock the interface
            });
        }
      });
      /* istanbul ignore next */
      if (this.overallRating === '') {
        this.overallRating = 0;
      }
    },
  },
};
</script>
